'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-levies-manager',
  _template: html`
  <style>
  :host {
    display: block;
  }
  </style>
    <dom-repeat items="{{levies}}" as="levy" id="list"> 
    <template is="dom-repeat">
     <paper-item class="layout horizontal" hidden$="{{_shouldHide(levy._destroy)}}">
     <paper-input label="levy name" value="{{levy.name}}" class="flex-4 h-spaced"></paper-input>
      <paper-input label="Levy rate" value="{{levy.rate}}" on-value-changed="_calculateOutput" class="flex-1 h-spaced"><div suffix>%</div></paper-input>
      <paper-dropdown-menu label="Select Position" class="flex-2 h-spaced" always-float-label>
        <paper-listbox slot="dropdown-content" class="dropdown-content flex" selected="{{levy.levy_position_id}}" on-iron-select="_modifyLevies">
          <template is="dom-repeat" items={{positions}} as="p">
            <paper-item>[[p.name]]</paper-item>
          </template>
        </paper-listbox>
      </paper-dropdown-menu>
      <paper-input label="Levy Amount" value="{{levy.amount}}" readonly="true" class="flex-1 h-spaced"></paper-input>
      <paper-toggle-button id="billed" checked={{levy.billed}} on-iron-change="_calculateOutput">Billed</paper-toggle-button>
      <div class="flex-1">
       <paper-icon-button icon="delete" on-tap="_deleteLevy"></paper-icon-button>
     </div>
   </paper-item>
 </template>
 </dom-repeat>
 <iron-ajax
 auto
 url="{{url}}"
 handle-as="json"
 last-response="{{leviesAll}}"
 on-response="handleResponse"></iron-ajax>
 <div class="layout horizontal">
  <paper-dropdown-menu label="Add Levy" class="flex-4 h-spaced" id="ldd">
   <paper-listbox slot="dropdown-content" class="dropdown-content filters flex">
     <template is="dom-repeat" items="{{leviesAll}}" as="levy">
      <paper-item id="new_levy_[[levy.id]]" lid="[[levy.id]]" name="[[levy.name]]" rate="[[levy.rate]]">[[levy.name]] ([[levy.rate]] %)</paper-item>
    </template>
  </paper-listbox>
</paper-dropdown-menu>
<paper-dropdown-menu label="Select Position" class="flex-2 h-spaced" id="pdd">
  <paper-listbox slot="dropdown-content" class="dropdown-content flex">
    <template is="dom-repeat" items={{positions}} as="p">
      <paper-item pid="[[p.id]]">[[p.name]]</paper-item>
    </template>
  </paper-listbox>
</paper-dropdown-menu>
<div class="flex-1 h-spaced self-end">
  <paper-button on-tap="addLevy"><iron-icon icon="add"></iron-icon>Add</paper-button>
</div>
</div>
  `,
  properties: {
    levies: {
      type: Array,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    total_income: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    gross_income: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    net_income: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    nonBilled: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    outcome: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    url: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    },
    field: {
      type: String,
      notify: true,
      reflectToAttribute: true,
      readOnly: false
    }
  },
  ready: function () {
    this.positions = [{id: '0', name: 'Gross Income'}, {id: '1', name: 'Net Income'}, {id: '2', name: 'Total Income'}]
    this.income = [this.gross_income, this.net_income, this.total_income]
  },
  addLevy: function () {
    let l = this.$.ldd.selectedItem
    let p = this.$.pdd.selectedItem
    let newLevy = { 'levy_position_id': p.pid, 'name': l.name, 'rate': l.rate, 'amount': (this.income * l.rate / 100).toFixed(2), 'billed': true }
    this.push('levies', newLevy)
    this._calculateOutput()
  },
  _modifyLevies: function (e) {
    this._calculateOutput()
  },
  handleResponse: function (e) {
  },
  _calculateOutput: function () {
    var myIncome = this.income
    var myOutcome = 0.0
    var myNonBilled = 0.0
    let length = this.levies.length
    for (let i = 0; i < length; i++) {
      if (this.levies[i]._destroy != 'true' && this.levies[i].billed) {
        this.set('levies.' + i + '.amount', (myIncome[this.levies[i].levy_position_id] * this.levies[i].rate / 100).toFixed(2))
        myOutcome += parseFloat(this.levies[i].amount)
      } else if (this.levies[i]._destroy != 'true' && !this.levies[i].billed) {
        this.set('levies.' + i + '.amount', (myIncome[this.levies[i].levy_position_id] * this.levies[i].rate / 100).toFixed(2))
        myNonBilled += parseFloat(this.levies[i].amount)
      }
    };
    this.set('outcome', myOutcome)
    this.set('nonBilled', myNonBilled)
    let arr = this.levies
    this.levies = []
    this.levies = arr
  },
  _deleteLevy: function (e) {
    var index = this.levies.indexOf(e.model.get('levy'))
    // this.splice('levies', index, 1);
    this.set('levies.' + index + '._destroy', 'true')
    var arr = this.levies
    this.levies = []
    this.levies = arr
    this._calculateOutput()
  },
  _shouldHide: function (c) {
    return c === 'true'
  }
})
